import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'
import commonJs from '@/utils/common'
const BASE_URL = baseUrl +'/device'
export default {
	/**
	 * 路灯列表
	 * @param {is_double} 0单灯 1双灯
	 * @param {stg_id} 策略的id
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	lightList( params={} ) {
		params = commonJs.obj.removeNullKey(params)
		return request({
	    url: BASE_URL + '/lamps',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 路灯详情
	 * @param {lampId} 路灯id
	**/
	lightInfo(id) {
		return request({
	    url: BASE_URL + '/lampsInfo/'+id,
	    method: 'GET'
	  })
	},

	/**
	 * 电能情况
	 * @param {lampId} 路灯id
	**/
	powerInfo(id) {
		return request({
	    url: BASE_URL + '/getElectricityDnergyDesc/'+id,
	    method: 'GET'
	  })
	},

	/**
	 * 路灯添加
	**/
	lightAdd(data){
		return request({
			url: BASE_URL + '/lamps',
			method:'POST',
			data
		})
	},

	/**
	 * 路灯编辑
	**/
	lightEdit(id,data){
		return request({
			url: BASE_URL + '/lamps/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * 路灯删除
	**/
	lightDel(id){
		return request({
			url: BASE_URL + '/lamps/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 给路灯分配策略 ms:0自动,1手动
	**/
	lightStrategysSave(id,data){
		return request({
			url: BASE_URL + '/Strategys/'+id,
			method:'POST',
			data
		})
	},

	/**
	 * 路灯控制(1手动)
	**/
	lightControl(data){
		return request({
			url: BASE_URL + '/control',
			method:'POST',
			data
		})
	},

	/**
	 * 路灯设为首页显示
	**/
	lightSetHome(id,data){
		return request({
			url: BASE_URL + '/SetHome/'+id,
			method:'POST',
			data
		})
	},

	/**
	 * 设置倾斜角相对绝对
	**/
	lightSetAngle(id,data){
		return request({
			url: BASE_URL + '/setAngle/'+id,
			method:'POST',
			data
		})
	},

	/**
	 * 回路控制
	 * @param {id} 网关ID
	**/
	lampLoopControl(id,data){
		return request({
			url: BASE_URL + '/lampLoopControl/'+id,
			method:'POST',
			data
		})
	},

	/**
	 * 回路控制
	 * @param {id} 网关ID
	**/
	getLoopList(id) {
		return request({
	    url: BASE_URL + '/getLoopList/'+id,
	    method: 'GET'
	  })
	},

	/**
	 * 导入文件
	**/
	importExcel(data) {
		return request({
	    url: BASE_URL + '/importExcel',
	    method:'POST',
		data
	  })
	},

	/**
	 * 批量设置路灯自动手动
	**/
	setAutoControl(data) {
		return request({
	    url: BASE_URL + '/setAutoControl',
	    method:'POST',
		data
	  })
	},

	/**
	 * 所属用户列表
	**/
	lampUserList( params={} ) {
		return request({
	    url: baseUrl + '/auth/getUser',
	    method: 'GET',
	    params
	  })
	}
}